import React from "react";

type HighlightContextValue = boolean;

const HighlightContext = React.createContext<HighlightContextValue>(false);

export default HighlightContext;
